import { Icon } from './_Icon';
export const AIIcon = (props) => (
  <Icon {...props} d="M3 8h18v12H3z M9 13.5v1 M15 13.5v1 M12 8V4 M11 3h2" />
);
